import React from 'react';
import { Experience as ExperienceType } from '../types/ProfileTypes';

interface ExperienceProps {
  data: ExperienceType[] | undefined;
}

const formatDate = (date: string | { year: number; month?: number; day?: number } | undefined | null): string => {
  if (!date) return 'Present';
  if (typeof date === 'string') {
    return new Date(date).toLocaleString('en-US', { month: 'short', year: 'numeric' });
  }
  const { year, month } = date;
  return `${month ? new Date(year, month - 1).toLocaleString('en-US', { month: 'short' }) : ''} ${year}`;
};

const formatDescription = (description: string): string => {
  return description.split('•').join('\n•');
};

const Experience: React.FC<ExperienceProps> = ({ data }) => {
  if (!data || data.length === 0) return null;

  return (
    <section className="bg-gray-800 shadow-lg rounded-lg p-6">
      <h2 className="text-2xl font-bold mb-4 text-white">Experience</h2>
      <div className="space-y-6">
        {data.map((exp, index) => (
          <div key={index} className="border-b border-gray-700 pb-6 last:border-b-0 last:pb-0">
            <div className="flex items-center mb-2">
              {/*
              <div className="w-8 h-8 mr-2 relative">
                 
                <img 
                  src={`https://logo.clearbit.com/${exp.company.toLowerCase().replace(/\s/g, '')}.com`} 
                  alt={`${exp.company} logo`}
                  className="w-full h-full object-contain absolute inset-0"
                  onError={(e) => { (e.target as HTMLImageElement).style.display = 'none' }}
                />
              </div>
              */}
              <h3 className="text-xl font-semibold text-white">{exp.title}</h3>
            </div>
            <p className="text-gray-300">{exp.company}</p>
            {exp.location && <p className="text-gray-300">{exp.location}</p>}
            <p className="text-gray-300">
              {formatDate(exp.startDate)} - {formatDate(exp.endDate)}
            </p>
            {exp.description && (
              <p className="text-gray-400 mt-2 whitespace-pre-line">
                {formatDescription(exp.description)}
              </p>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Experience;